import { Copy, ExternalLink } from "lucide-react"
import { Button } from "../../ui"
import { showToastSuccess } from "utilities/toastUtil"

export const proposalLink = (proposal) =>
  proposal.url ? `${window.location.origin}/${proposal.url}` : null

const copyLink = async (link) => {
  await navigator.clipboard.writeText(link)
  showToastSuccess("Đã copy link.")
}

// Copy + Open, reused in the table's Link column and in the expanded-row
// detail. There's no manual "mark as selected" action here: the backend
// auto-selects the first supplier to quote at least one item, and otherwise
// only changes the selection when a PO is created from a proposal.
export default function LinkActions({ link }) {
  if (!link) return "—"
  return (
    <div style={{ display: "flex", gap: 6 }}>
      <Button variant="ghost" size="sm" leftIcon={<Copy size={14} aria-hidden />} onClick={() => copyLink(link)}>
        Copy
      </Button>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="pc-btn pc-btn--ghost pc-btn--sm"
        style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
      >
        <ExternalLink size={14} aria-hidden /> Open
      </a>
    </div>
  )
}
